import { atom } from 'recoil';

export const IsRenameDsState = atom<boolean>({
  key: 'is-rename-datasource-state',
  default: false,
});

export const RenameDsNameState = atom<string>({
  key: 'rename-datasource-name-state',
  default: '',
});
